import isTarget from '../targeting/isTarget';

/**
 * Strategem used only as a targeting-rules proxy for Explore Unknown EP - Target spend.
 * Must match `isTarget` checks in BattleUI click handlers.
 */
export const EXPLORE_UNKNOWN_EP_TARGET_STRATEGEM_PROXY_ID = 60;

/**
 * @param {Object} params
 * @param {Object} params.unit
 * @param {string} params.zone - Battlefield zone key (e.g. opponent_front, front)
 * @param {Object} params.gameState
 * @param {string|number} params.playerId
 * @param {Object} params.targetingData
 * @returns {boolean}
 */
export function isExploreUnknownEpTargetUnit({ unit, zone, gameState, playerId, targetingData }) {
  if (!unit?.instanceId) return false;
  return isTarget({
    strategemTargetMode: true,
    selectedStrategemId: EXPLORE_UNKNOWN_EP_TARGET_STRATEGEM_PROXY_ID,
    zone,
    gameState,
    playerId,
    unit,
    targetingData,
  });
}
